import React, { Component } from 'react';
import $ from 'jquery';
import DataTablesCreate from "./DataTablesCreate";

let headers = [
    {title: 'Name'},
];

class SeriesCreateModal extends Component {
    componentDidMount() {
        this.closeAction();
    }

    closeSeries = async () => {
        $('#seriesDocumentsModal').modal('hide');
    }

    closeAction = () => {
        const { cleanData } = this.props;
        $('#seriesDocumentsModal').on('hidden.bs.modal', function () {
            //console.log("cerrar Series");
            cleanData();
        });
    };

    render() {
        const {data, selectSerie} = this.props;
        if(data.length === 0){
            return <div className="modal fade bd-example-modal-lg bgtransparent"  role="dialog"  id="seriesDocumentsModal"></div>;
        }

        return (
            <div>
                <div className="modal fade bd-example-modal-lg modal-open scroll"  role="dialog"  id="seriesDocumentsModal" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg modal-open" role="document">
                        <div className="modal-content">

                            <div className="modal-header text-white" style={{backgroundColor:'#343a40',borderRadius:'0'}}>
                                <h4 className="modal-title" id="modal-basic-title ">Series</h4>
                                <button type="button" className="close" onClick={this.closeSeries} aria-label="Close">
                                    <span className="text-white" aria-hidden="true">&times;</span>
                                </button>
                            </div>

                            <div className="modal-body" >
                                <div className="contanier">
                                    <div className="row justify-content-around">
                                        <div className="col-12">
                                            <div className="table-responsive">
                                                <table className="table response" style={{marginBottom: 0}}>
                                                    <tbody>
                                                    <DataTablesCreate data={data} headers={headers} view={"seriesModal"} action={selectSerie}/>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="btn botonCerrar text-white" onClick={this.closeSeries}>Cerrar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default SeriesCreateModal;